<div class="operation-menus-two-levels">
  @for (operation of operations; track $index) {
    <div>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="operationContainer.rootSectionsContainer?.rootObject.read_only"
        (click)="openOperation(operation)"
      >
        <i
          class="{{operation.menu_icon}}
          menuItem-icon"
        ></i>

        <span class="bold uppercase">
          {{ operation.menu_title | translate }}
        </span>
      </button>

      @if (operation.$$showOperationMenu) {
        <div>
          @for (subOperation of operation.sub_operations; track $index) {
            <button
              mat-stroked-button
              color="primary"
              type="button"
              (click)="openOperation(subOperation)"
            >
              <i
                class="{{subOperation.menu_icon}} menuItem-icon"
              ></i>

              <span class="bold uppercase">
                {{ subOperation.menu_title | translate }}
              </span>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
